<template>
    <v-form-field v-bind="$props">
        <template v-slot:append>
            <slot name="append"></slot>
        </template>
        <template v-slot:label-prepend>
            <slot name="label-prepend"></slot>
        </template>
        <template v-slot:label-append>
            <slot name="label-append"></slot>
        </template>
        <template v-slot:label>
            <slot name="label"></slot>
        </template>
        <template v-slot:content>
            <slot name="content">
                <v-menu
                        v-model="showDatePicker"
                        close-on-content-click
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field :autofocus="autofocus" autocomplete="off"
                                      class="form-input__border" solo
                                      flat
                                      :placeholder="placeholder"
                                      :disabled="readonly"
                                      hide-details single-line dense v-model="componentValue"
                                      @keydown="onKeydown"
                                      readonly
                                      clearable
                                      v-bind="attrs"
                                      v-on="on">
                            <template v-slot:prepend-inner>
                                <v-icon small>mdi-clock-outline</v-icon>
                            </template>
                        </v-text-field>
                    </template>
                    <v-date-picker
                            locale="zh"
                            v-model="componentValue"
                    ></v-date-picker>
                </v-menu>
            </slot>
        </template>
    </v-form-field>
</template>
<script>
    export default {
        name: "FormDateSelector.vue",
        model: {
            prop: 'dateValue',
            event: 'input'
        },
        props: {
            small: {
                type: Boolean,
                default: false
            },
            xSmall: {
                type: Boolean,
                default: false
            },
            xxSmall: {
                type: Boolean,
                default: false
            },
            middle: {
                type: Boolean,
                default: false
            },
            large: {
                type: Boolean,
                default: false
            },
            xLarge: {
                type: Boolean,
                default: false
            },
            xxLarge: {
                type: Boolean,
                default: false
            },
            label: {
                type: String
            },
            disable: {
                type: Boolean,
                default: false,
            },
            readonly: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: "选择日期"
            },
            autofocus: {
                type: Boolean,
                default: false
            },
            labelWidth: {
                type: Number
            },
            fieldWidth: {
                type: Number,
                default: 150
            },
            hideLabel: {
                type: Boolean,
                default: false
            },
            removeLabel: {
                type: Boolean,
                default: false
            },
            items: String,
            dataItems: {
                type: Array
            },
            value: null,
            dataApi: String,
            itemText: {
                type: String,
                default: 'text'
            },
            itemValue: {
                type: String,
                default: 'value'
            },
            dataQueryParam: {},
            dateValue: {
                type: String
            }
        },
        data() {
            return {
                showDatePicker: false,
                componentValue: this.dateValue
            }
        },
        watch: {
            dateValue(val) {
                this.componentValue = val;
            },
            componentValue(val) {
                this.$emit('input', val);
            },
        },
        created() {
            if (this.value) {
                let ss = this.value.split(" ");
                this.textContent = ss[0];
            }
        },
        methods: {
            onKeydown(e) {
                if (e.keyCode === 13) {
                    this.$emit('enter', e);
                }
            }
        }
    }
</script>